export default "__VITE_ASSET__BcMxhhqw__"